import type { NavItem } from "@/types/nav-item.types";

/**
 * Resolves the logo URL for the currently active nav item (or its active sub-item).
 */
export function getActiveNavLogoUrl(
    navItems: NavItem[],
    defaultLogoUrl: string,
    transform?: (url: string) => string,
): string {
    const apply = (url?: string): string => {
        if (!url) return defaultLogoUrl;
        return transform ? transform(url) : url;
    };

    for (const item of navItems) {
        const activeSubItem = item.subItems?.find((sub) => sub.isActive);

        if (activeSubItem) {
            return apply(activeSubItem.logoUrl ?? item.logoUrl);
        }

        if (item.isActive) {
            return apply(item.logoUrl);
        }
    }

    return defaultLogoUrl;
}
